import { Box } from '@mui/material';
import comingsoon from "../../../assets/commingsoon.png";
import CustomText, { textStyles } from "../../../components/CustomText";
import { useTranslation } from "react-i18next";

const Applicants = () => {
          const { t } = useTranslation();
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '80vh',
        backgroundColor: '#f9fafb',
        textAlign: 'center',
        gap: 2,
      }}
    >
      <Box
        component="img"
        src={comingsoon}
        alt="Coming Soon"
        sx={{
          width: { xs: '70%', sm: '300px' },
          borderRadius: '16px',
          boxShadow: '0 6px 18px rgba(0,0,0,0.1)',
          border: '2px solid #e0e0e0',
        }}
      />
   
         <CustomText
                  sx={{
                    fontSize: 24,
                    fontWeight: 600,
                    color: "#2C384C",
                    fontFamily: "Poppins, sans-serif",
                  }}
                >
             {t("comingSoon.coming_soon")}
                </CustomText>

    </Box>
  );
};

export default Applicants;